<template>
    <div
        :class="{'employee_status_icon': true, 'small': small }"
        :style="{ backgroundColor: color }"
        :title="title"
    >
        <i
            class="icon icon-inverse"
            :class="classes"
        ></i>
    </div>
</template>

<script>
import Employee from '../../../js/dto/Employee';

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        spinning: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        status: {
            type: Number,
            required: false,
            example: 1,
        },
        small: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        classes() {
            let classes = [];
            classes.push('icon-' + this.icon);
            if (this.spinning) {
                classes.push('icon-pulse');
            }
            return classes;
        },
        icon() {
            if (this.spinning) {
                return 'spinner';
            }
            switch (this.status) {
                case Employee.CONTRACT_STATUS_ACTIVE:
                    return 'check';
                case Employee.CONTRACT_STATUS_SCHEDULED:
                    return 'clock';
                case Employee.CONTRACT_STATUS_INACTIVE:
                    return 'close';
                default:
                    return 'circle-o';
            }
        },
        color() {
            if (this.disabled) {
                return '#cbcbcb';
            }
            switch (this.status) {
                case Employee.CONTRACT_STATUS_ACTIVE:
                    return '#4CAF50';
                case Employee.CONTRACT_STATUS_SCHEDULED:
                    return '#FFC107';
                case Employee.CONTRACT_STATUS_INACTIVE:
                    return '#F44336';
                default:
                    return '#cbcbcb';
            }
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.employee_status_icon {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    border-radius: 50%;
    &.small {
        width: 15px;
        height: 15px;
    }
}
</style>
